import styled, { StyledFunction } from "styled-components";

// import IStep from "./Step";
import { Table, Col, Row } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr> td {
        font-size: 11px;
    }
`;

export const MoveTrackStepWrapper = styled.div`
    height: 30px;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    position: relative;
    //max-width: 200px;
`;

export const MoveTrackerStepContentWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 20px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
`;

interface IMoveTrackerStepLabelProps {
    color?: string,
    badgeColor?: string
}

export const MoveTrackerStepLabelWrapper = styled.div`
    color: ${(p: IMoveTrackerStepLabelProps) => p.color ? p.color : "white"};
    opacity: 1;
    font-size: 16px;
    font-weight: 600;

    & > .badge {
        background-color: ${(p: IMoveTrackerStepLabelProps) => p.badgeColor ? p.badgeColor + " !important" : "#777"}
        color: ${(p: IMoveTrackerStepLabelProps) => p.color ? p.color : "#fff"}
    }
`;

export const MoveTrackerRowWrapper = styled(Row)`
    font-size: 12px;
`;

export const MoveTrackerColWrapper = styled(Col)`
    padding-left: 5px;
    padding-right: 5px;
    min-height: ${p => p.height ? p.height + "px" : "40px"};
    display: flex;
    align-items: center;
`;

export const NotesWrapper = styled.div`
    width: 100%;
    border: 1px solid #ddd;
    padding: 5px;

    :hover {
        background-color: #ddd;
        cursor: text;
    }
`;

// export const TableHeadWrapper = styled.thead<{ fontSize?: number }>`
//     & > tr > th {
//         padding: 3px !important;
//         font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
//         text-align: center;
//     }
// `;

// export const TableBodyWrapper = styled.tbody<{ fontSize?: number }>`
//     & > tr > td {
//         font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
//         padding: 0px !important;
//         text-align: center;
//     }

//     & > tr > td > div > div > span {
//         font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
//     }
// `;

export const TableHeadWrapper = styled.thead<{ fontSize?: number, borderColor?: string, backgroundColor?: string, textColor?: string }>`
    & > tr > th {
        padding: 3px !important;
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        text-align: center;
        border-bottom: ${p => p.borderColor ? '0 none !important' : 'inherit !important'};
        background-color: ${p => p.backgroundColor ? p.backgroundColor : 'white'};
        color: ${p => p.textColor ? p.textColor : '#333'};
    }
`;

export const TableBodyWrapper = styled.tbody<{ fontSize?: number, borderColor?: string }>`
    & > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        padding: 0px !important;
        text-align: center;
    }

    & > tr:last-child > td {
        border-bottom: ${p => p.borderColor ? '1px solid ' + p.borderColor + ' !important' : ''};
    }

    & > tr > td > div > div > span {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }
`;